module.exports = __webpack_public_path__ + "static/media/looptv_chime.1234bf74.wav";